export default "__VITE_ASSET__BB13g7fC__"